import styled from 'styled-components';

const Background = styled.div`
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 999;
`;

export default Background;



// WEBPACK FOOTER //
// ./app/components/Modal/Background.js